//@ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl, { Map } from '!mapbox-gl';
import { useEffect, useRef, useState } from 'react';
import './mapbox-min.css';
import './index.css';
import config from '../../config';

const MapComponent = (props: iProps) => {
  const MAPBOX_KEY = config.MAPBOX_KEY;

  mapboxgl.accessToken = MAPBOX_KEY;

  const mapContainer = useRef<HTMLDivElement>(document.createElement('div'));
  const map = useRef<Map | null>(null);
  const [lat, setLat] = useState(props.latitude || -70.9);
  const [lng, setLng] = useState(props.longitude || 42.3);
  const [zoom, setZoom] = useState(15);
  const [markers, setMarkers] = useState<any[]>([]);
  const [driverInfoMarker, setDriverInfoMarker] = useState<any>();

  useEffect(() => {
    if (map.current) return; // initialize map only once

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [lng, lat],
      zoom: zoom
    });

    map.current.addControl(
      new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true
        },
        // When active the map will receive updates to the device's location as it changes.
        trackUserLocation: false,
        // Draw an arrow next to the location dot to indicate which direction the device is heading.
        showUserHeading: true,
      })
    );

    const setLocation = (latitude: number, longitude: number) => {
      props.callBack({latitude, longitude});

      if (!props.hideMark) {
        // const el = document.createElement('i');
        // el.style.backgroundColor = 'red';

        const marker = new mapboxgl.Marker({color: 'red'})
          .setLngLat([lng, lat])
          .addTo(map.current);

        marker.setLngLat([longitude, latitude]);
      }
    }

    setLocation(lat, lng);

    map.current.on('click', (e) => {
      setLocation(e.lngLat.lat, e.lngLat.lng)
    });

    map.current.on('dragend', (e) => {
      const center = map.current?.getCenter();
      if (!center) return;
      setLocation(center.lat, center.lng);
    });

    map.current.on('zoomend', (e) => {
      const center = map.current?.getCenter();
      if (!center) return;
      setLocation(center.lat, center.lng);
    });
  }, []);

  useEffect(() => {
    if (!map.current || !props.markList) return;

    markers.forEach((marker) => {
      marker.remove();
    });

    const newMarkers = props.markList.map((item) => {
      const el: any = item.className ? document.createElement('i') : {color: 'black'}

      if (item.className){ 
        el.className = item.className;
        el.style.fontSize = '3rem';
        el.style.fontWeight = 'bold';
        // el.style.backgroundColor = 'red';
      }

      if (item.color) el.style.color = item.color;

      const marker = new mapboxgl.Marker(el)
        .setLngLat([item.longitude, item.latitude])
        .addTo(map.current);

      marker.setLngLat([item.longitude, item.latitude]);

      marker.getElement().addEventListener('click', () => {
        if (driverInfoMarker) driverInfoMarker.remove();

        const elinfo = document.createElement('div');

        elinfo.style.fontSize = '2rem';
        elinfo.style.fontWeight = 'bold';
        elinfo.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        elinfo.style.color = 'white';
        elinfo.style.padding = '5px';
        elinfo.style.borderRadius = '10px';
        elinfo.style.display = 'flex';
        elinfo.style.flexDirection = 'column';

        const info = document.createTextNode(`${item.name}`);
        const nameSpan = document.createElement('span');
        nameSpan.appendChild(info);

        const infoPhone = document.createTextNode(`${item.phone}`);
        const phoneSpan = document.createElement('span');
        phoneSpan.style.marginTop = '10px';
        phoneSpan.appendChild(infoPhone);

        elinfo.appendChild(nameSpan);
        elinfo.appendChild(phoneSpan);

        const driverMarker = new mapboxgl.Marker(elinfo)
          .setLngLat([item.longitude, item.latitude])
          .addTo(map.current);

          driverMarker.setLngLat([item.longitude, item.latitude]);

        setDriverInfoMarker(driverMarker)
      });

      return marker;
    });

    setMarkers(newMarkers);
  }, [props.markList, map.current]);

  useEffect(() => {
    if (props.latitude) setLat(props.latitude);

    if (props.longitude) setLng(props.longitude);
  }, [props.latitude, props.longitude]);

  useEffect(() => {
    if (map.current) map.current.setCenter([lng, lat]);
  }, [lat, lng]);

  return (
    <div>
      <div ref={mapContainer} className="map-container" />
    </div>
  );
}

export default MapComponent;

interface iProps {
  latitude?: number,
  longitude?: number,
  callBack: Function,
  hideMark?: boolean,
  markList?: iCarMarkers[],
}
